import { toast } from "sonner";

/** The message of the error the gated clipboard throws when today's trial uses are gone (hooks/useLogToolUsage). */
export const COPY_BLOCKED_MESSAGE = "Daily limit reached";

/** True when `err` is the gated clipboard refusing a copy: the paywall is already open, nothing was copied. */
export function isCopyBlocked(err: unknown): boolean {
  return err instanceof Error && err.message === COPY_BLOCKED_MESSAGE;
}

/**
 * Copy text and say so only when it really was copied. The success toast waits for the clipboard: when the trial
 * limit blocks the copy the paywall is already showing and no "Copied" toast appears (B-0156, ASCII Art L-216).
 * A real clipboard failure gets an honest error. Resolves true when the text reached the clipboard.
 */
export async function copyText(text: string, successMessage?: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    if (!isCopyBlocked(err)) toast.error("Couldn't copy. Select the text and copy it by hand.");
    return false;
  }
  if (successMessage) toast.success(successMessage);
  return true;
}
